import { getSelectedWikiDevice, setInputFormValue } from 'Shared/ifixit_store';
import AjaxIO from 'Shared/utils';

/**
 * Used for Guide/UI/templates/Misc/chosen_topic.phtml
 */
export class CategoryCard {
   private deviceField: HTMLElement;
   private device: HTMLElement;
   private image: HTMLElement;
   private title: HTMLElement;
   private displayTitle: HTMLElement;
   private summary: HTMLElement;

   constructor(deviceField: HTMLElement, exampleText = '') {
      this.deviceField = deviceField;
      this.device = document.querySelector('.chosen-device') as HTMLElement;
      this.image = document.querySelector('.device-image')?.children[0] as HTMLElement;
      this.title = document.querySelector('.device-title') as HTMLElement;
      this.displayTitle = document.querySelector('.device-display-title') as HTMLElement;
      this.summary = document.querySelector('.device-summary') as HTMLElement;

      this.deviceField?.addEventListener('blur', () => {
         const current = this.deviceField.classList.contains('react-component')
            ? // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
              getSelectedWikiDevice().trim()
            : this.deviceField
                 // @ts-expect-error because .get() is mootools
                 .get('value')
                 .trim();
         if (current && current !== exampleText) {
            this.toggleDeviceBlurb(true);
         }
      });

      document.querySelector('.change-button')?.addEventListener('click', () => {
         // If a user exits out of a category card device selection we should:
         //   - fill the search box text with the recently selected device's title
         //   - hide the category card and display the search box again
         //   - focus on the search box
         setInputFormValue(this.displayTitle.textContent!);
         this.toggleDeviceBlurb(false);

         // focus on appropriate element depending if we are in
         //  answers/ask or guide/intro and guide/new
         const introDevice = document.querySelector('.introDevice') as HTMLElement | null;
         const target: HTMLElement = introDevice || this.deviceField;
         target.focus();
      });
   }

   public toggleDeviceBlurb(show: boolean) {
      if (!this.deviceField) return;
      const searchBox = this.deviceField.children
         ? Array.from(this.deviceField.children).find(e => e.classList.contains('topicChooser'))
         : null;
      if (show) {
         if (searchBox) {
            searchBox.classList.add('hidden');
         } else {
            this.deviceField.classList.add('hidden');
         }
         this.device.classList.remove('hidden');
      } else {
         this.deviceField.classList.remove('hidden');
         searchBox?.classList.remove('hidden');
         this.device.classList.add('hidden');
      }
   }

   public setDeviceInfo(
      title?: string,
      image?: string,
      summary?: string,
      displayTitle?: string,
      query?: string
   ) {
      title = title || query;
      new AjaxIO('getDeviceInfo', {
         onSuccess: function (data: any) {
            const imageToSet = image || data.image;
            // @ts-expect-error TS(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
            if (this.image) this.image.setAttribute('src', imageToSet);
            // @ts-expect-error TS(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
            if (this.title) this.title.textContent = title || data.title || '';
            // @ts-expect-error TS(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
            if (this.displayTitle)
               // @ts-expect-error TS(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
               this.displayTitle.textContent = displayTitle || data.display_title || '';
            // @ts-expect-error TS(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
            if (this.summary) this.summary.innerHTML = summary || data.summaryHTML || '';
         }.bind(this),
         // @ts-expect-error TS(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      }).send(encodeURIComponent(title));
   }
}
